import { render, staticRenderFns } from "./EcommerceStatistics.vue?vue&type=template&id=6ba489ae&"
import script from "./EcommerceStatistics.vue?vue&type=script&lang=js&"
export * from "./EcommerceStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports